import { render } from "./TeacherAssignmentsView.vue?vue&type=template&id=407d98d2"
import script from "./TeacherAssignmentsView.vue?vue&type=script&lang=js"
export * from "./TeacherAssignmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__